import React from 'react';
import { jsx as ___EmotionJSX } from "@emotion/core";
var WatchlistStar = () => ___EmotionJSX("g", {
  transform: "translate(4 4)",
  fill: "#ffa200"
}, ___EmotionJSX("path", {
  strokeWidth: "0.5%",
  stroke: "#FC0",
  d: "M.298 4.358A.759.759 0 0 1 .76 2.994h2.653L4.287.502A.742.742 0 0 1 4.995 0c.324 0 .602.197.709.502l.874 2.492h2.666a.756.756 0 0 1 .459 1.355L7.605 5.952l1.06 3.008a.77.77 0 0 1-.277.884.77.77 0 0 1-.926-.011L4.995 7.949 2.527 9.834a.773.773 0 0 1-1.202-.872l1.056-3.01L.298 4.358z"
}));
export default WatchlistStar;